import styles from './index.module.scss'
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ProDetailListTop from '../components/ProDetailListTop'
import PictureResultItem from '../../components/PictureResultItem'
import PictureViewModal from '../../components/PictureViewModal'
import ChangeModel from '../../components/ChangeModelAndBg'
import API, { commonApiInvoker } from '@api/api.js';
import { useProjectGroupedTasks } from '@view/page_v3/hooks/ProjectDetailSort'
import ProjectDetailGroupsTitle from '@view/page_v3/components/ProjectDetailGroupsTitle'
import PSAIModal from '@PSAIComponents/PSAIModal';
import { message, Button, Modal } from 'antd';
import Utils from '@utils/utils'
import { workflowOfLoadTaskInfo, workflowOfReGenerate, workflowOfReplica } from '@utils/workflowOfBuildTaskV2';
import { AppContext } from '@utils/AppContext';
import ReplicaForm from '@view/compoents/ReplicaForm'
import { IMAGE_TYPE, DISPLAY_TYPE, SMART_DETAIL_COMP_LABEL_MAP } from '../../../../utils/CONST';
import { CloseOutlined } from '@ant-design/icons';
import SmartDetailPagePreview from '@view/page_v3/MiddleComp/SmartDetailPagePreview'
import PreviewBottomActions from '@view/page_v3/MiddleComp/SmartDetailPagePreview/components/PreviewBottomActions'
import MaterialEditModal from '@view/page_v3/MiddleComp/SmartDetailPagePreview/MaterialEditModal'
import Iconfont from '@utils/Iconfont'


const ProjectDetailPage = (props) => {
    const { setGlobalTaskReadFlag, forceUpdate, proSidebarValue, setProSidebarValue } = useContext(AppContext)
    const { projectId } = useParams()
    const location = useLocation()
    const modalRef = useRef()
    const changeModelRef = useRef()
    const [isSelected, setIsSelected] = useState(false) // 是否选择
    const [selectedList, setSelectedList] = useState([]) // 已选列表
    const [downLoading, setDownLoading] = useState(false)
    const [messageApi, contextHolder] = message.useMessage();
    const navigate = useNavigate()

    // 大图弹窗
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [item, setItem] = useState()
    const [taskId, setTaskId] = useState()
    const [modalOpenFlag, setModalOpenFlag] = useState(false)
    useEffect(() => {
        if (projectId !== 'collect') return
        const searchParams = new URLSearchParams(location.search)
        const moduleFromQuery = searchParams.get('module')
        if (moduleFromQuery && moduleFromQuery !== proSidebarValue) {
            setProSidebarValue(moduleFromQuery)
        }
    }, [projectId, location.search, proSidebarValue, setProSidebarValue])

    useEffect(() => {
        if (!isModalOpen) {
            setTaskId()
            setItem()
        }
    }, [isModalOpen])
    const handleCLick = (item) => {
        if (item.status != "succeeded") return
        setItem(item)
        setTaskId(item?.taskId)
    }
    useEffect(() => {
        if (item && taskId) {
            setIsModalOpen(true)
        }
    }, [item, taskId])


    // groupedTasks分组后、rawTasks分组前源数组、 fetchProjectDetail重新调用
    const { groupedTasks, rawTasks, fetchProjectDetail, imageType, resCode } = useProjectGroupedTasks(projectId)

    useEffect(() => {
        if (resCode == -5003) {
            navigate(-1)
        }
    }, [groupedTasks, resCode])

    const getIsSelected = (flag) => {
        setIsSelected(flag)
    }
    const selectCurrentItem = (id) => {
        if (selectedList.includes(id)) {
            setSelectedList(selectedList.filter(item => item !== id))
        } else {
            setSelectedList([...selectedList, id])
        }
    }

    const selectAll = () => {
        if (isSelectedAll) {
            setSelectedList([])
        } else {
            setSelectedList(rawTasks.map(item => item.taskId))
        }
    }

    const isSelectedAll = useMemo(() => {
        if (rawTasks.length == 0) return false
        return rawTasks.length == selectedList.length
    }, [selectedList, rawTasks])

    const deleteClick = () => {
        if (selectedList.length == 0) return
        PSAIModal.confirm({
            title: isSelectedAll ? "删除已选中及项目" : "删除已选中",
            content: isSelectedAll ? "请确认是否删除已选中及项目？" : "请确认是否删除已选中？",
            onOk: deleteProject
        })
    }

    const deleteProject = () => {
        commonApiInvoker(API.batchRemoveTaskv2({
            taskIds: selectedList,
            projectId
        })).then(res => {
            message.success('删除成功')
            setSelectedList([])
            fetchProjectDetail()
        })
    }

    const downClick = () => {
        if (selectedList.length == 0) return
        // const status = Utils.checkFirstDownLoad(() => downClickMeta())
        // if (!status) return
        downClickMeta()
    }

    const downClickMeta = () => {
        setDownLoading(true)
        commonApiInvoker(API.batchDownloadByTaskv2({
            taskIds: selectedList
        }), setDownLoading).then(res => {
            Utils.downloadFileWithToken(res).then(() => {
                message.success('下载成功');
            }).catch(() => {
                message.warning('下载失败，请稍后重试');
            }).finally(() => {
                setDownLoading(false)
            })
        })
    }


    const [recreateLoading, setRecreateLoading] = useState({})
    const createAgain = async (item1, groupIndex) => {
        if (item1?.[0]?.imageType == IMAGE_TYPE.WATERMARK_REMOVE) {
            return message.info('该功能已下架')
        }
        const succeededItem = item1.find(item => item.status === "succeeded") || item1.find(item => item.status === "failed");
        if (succeededItem) {
            try {
                setRecreateLoading(prev => ({ ...prev, [groupIndex]: true }))
                const taskID = succeededItem.taskId
                const res = await workflowOfReGenerate(succeededItem.imageType, taskID)
                if (!res) return
                const { disabled, pathname, options } = res
                if (disabled) {
                    message.warning("版本更新，请重新编辑后再重新生成")
                    navigate(pathname, options)
                } else {
                    message.success('生成中，请稍候！')
                    setGlobalTaskReadFlag(prev => !prev)
                    fetchProjectDetail()
                }
            } catch (err) {
                message.warning(err.message)
            } finally {
                setRecreateLoading(prev => ({ ...prev, [groupIndex]: false }))
            }
        } else {
            message.warning('请先等待生成成功后再重新生成')
        }
    }

    const [rebuildLoading, setRebuildLoading] = useState({})
    const rebuildClick = async (item1, groupIndex, commidityOldDataRebuild) => {
        if (item1?.[0]?.imageType == IMAGE_TYPE.WATERMARK_REMOVE) {
            return message.info('该功能已下架')
        }
        const succeededItem = item1.find(item => item.status === "succeeded") || item1.find(item => item.status === "failed");
        if (succeededItem) {
            try {
                setRebuildLoading(prev => ({ ...prev, [groupIndex]: true }))
                const res = await workflowOfLoadTaskInfo(succeededItem.imageType, succeededItem.taskId, commidityOldDataRebuild)
                if (!res) return
                const { pathname, options } = res
                navigate(pathname, options)
            } catch (err) {
                message.warning(err.message)
            } finally {
                setRebuildLoading(prev => ({ ...prev, [groupIndex]: false }))
            }
        } else {
            message.warning('生成中，请等待完成后再编辑')
        }
    }

    const changeModelOrSenceClick = (item, type) => {
        changeModelRef.current.handleClick(item, type)
    }

    const [materialModalOpen, setMaterialModalOpen] = useState(false)
    const [materialEditItem, setMaterialEditItem] = useState(null)
    const [materialGenerating, setMaterialGenerating] = useState(false)
    const openMaterialEditModal = (targetItem) => {
        if (!targetItem || targetItem?.status !== 'succeeded') return
        setMaterialEditItem(targetItem)
        setMaterialModalOpen(true)
    }
    const handleMaterialGenerate = async ({ desc, referImage, item: currentItem }) => {
        if (!currentItem?.taskId || !desc) return
        try {
            setMaterialGenerating(true)
            const res = await API.doEditDetailPage({
                taskId: currentItem.taskId,
                prompt: desc,
                refImage: referImage || '',
                meta: Number(currentItem?.comp ?? 0),
            })
            if (res?.code !== 0) throw new Error(res?.message || '生成失败')
            message.success('生成中，请稍候！')
            setMaterialModalOpen(false)
            setMaterialEditItem(null)
            fetchProjectDetail()
        } catch (err) {
            message.warning(err?.message || '生成失败')
        } finally {
            setMaterialGenerating(false)
        }
    }
    const handlePickImage = async (e, currentItem) => {
        e.stopPropagation()
        if (!currentItem?.taskId || currentItem?.status !== 'succeeded') return
        try {
            const res = await API.pickImage({
                taskIds: [currentItem.taskId]
            })
            if (res?.code !== 0) throw new Error(res?.message || '选图失败')
            fetchProjectDetail()
        } catch (err) {
            message.warning(err.message || '选图失败')
        }
    }

    // 复刻
    const [replicaNum, setReplicaNum] = useState(4)
    const [replicaOpen, setReplicaOpen] = useState()
    const [replicaOf, setReplicaOf] = useState()
    const [replicaFiles, setReplicaFiles] = useState([])

    const replicaCost = useMemo(() => {
        return replicaFiles.length * replicaNum * 10
    }, [replicaFiles, replicaNum])

    const handleReclipa = async (e, item) => {
        e.stopPropagation()
        setReplicaOpen(true)
        setReplicaOf(item)
    }
    const handleReplicaChange = (files, num) => {
        setReplicaFiles(files)
        setReplicaNum(num)
    }
    const key = 'replica'
    useEffect(() => {
        return () => {
            messageApi.destroy(key)
        }
    }, [])
    const handleReplicaOk = async () => {
        if (!replicaOf) return
        try {
            for (let index = 0; index < replicaFiles.length; index++) {
                const msgContent = `复用生成中[${Number(index) + 1}/${replicaFiles.length}]...`
                messageApi.open({
                    key,
                    type: 'loading',
                    content: msgContent,
                    duration: 0,
                })
                let tempFile = replicaFiles[index]
                setReplicaOpen(false)
                const res = await workflowOfReplica(replicaOf.imageType, replicaOf.taskId, tempFile, replicaNum)
                if (res) {
                    if (index == 0) forceUpdate({ jumpOnce: true })
                    else forceUpdate({})
                    fetchProjectDetail()
                }
            }
        } finally {
            messageApi.destroy(key)
        }
    }

    const IsEiEdit = useMemo(() => {
        return proSidebarValue == IMAGE_TYPE.AIEDIT || imageType == IMAGE_TYPE.DRESSFORM
    }, [proSidebarValue, imageType])
    const isSmartDetailProject = useMemo(() => imageType == IMAGE_TYPE.SMART_DETAILA_PAGE, [imageType])
    const pickedSortedItems = useMemo(() => {
        return (rawTasks || [])
            .filter(item => item?.picked)
            .map((item, index) => ({ item, index }))
            .sort((a, b) => {
                const aSortIdx = Number(a?.item?.attr?.sortIdx ?? a?.item?.sortIdx)
                const bSortIdx = Number(b?.item?.attr?.sortIdx ?? b?.item?.sortIdx)
                const aValue = Number.isFinite(aSortIdx) ? aSortIdx : Number.MAX_SAFE_INTEGER
                const bValue = Number.isFinite(bSortIdx) ? bSortIdx : Number.MAX_SAFE_INTEGER
                if (aValue !== bValue) return aValue - bValue
                return a.index - b.index
            })
            .map(({ item }) => item)
    }, [rawTasks])
    const previewImageUrls = useMemo(() => {
        return pickedSortedItems
            .map(item => item?.results?.[0]?.hdImage || item?.results?.[0]?.image)
            .filter(Boolean)
    }, [pickedSortedItems])
    const selectedTaskIds = useMemo(() => {
        return [...new Set(
            pickedSortedItems
                .map(item => item?.taskId)
                .filter(Boolean)
        )]
    }, [pickedSortedItems])
    const isSmartDetailGenerating = useMemo(() => {
        return (rawTasks || []).some(item => ['started', 'pending', 'processing'].includes(item?.status))
    }, [rawTasks])

    // 是否是企业项目
    const isOrgData = useMemo(() => {
        if (rawTasks.length == 0) return
        return rawTasks?.[0]?.orgData
    }, [rawTasks])


    return (
        <div className={styles.ProjectDetailPage}>
            <ProDetailListTop
                getIsSelected={getIsSelected}
                setSelectedList={setSelectedList}
                selectedList={selectedList}
                isSelectedAll={isSelectedAll}
                downLoading={downLoading}
                selectAll={selectAll}
                downClick={downClick}
                deleteClick={deleteClick}
            />
            <div className={`${styles.ProjectDetailPage_} ${isSmartDetailProject ? styles.ProjectDetailPageSmartDetail : '_beauty_scrollbar'}`}>
                <div className={isSmartDetailProject ? styles.SmartDetailPageWrapper : ''}>
                    <div className={`${styles.ProjectDetailPageContent} ${isSmartDetailProject ? `${styles.ProjectDetailMain} _beauty_scrollbar` : ''}`}>
                        {
                            groupedTasks.map((item1, index) => {
                            const displayItems = isSmartDetailProject
                                ? (item1 || [])
                                    .map((item, itemIndex) => ({ item, itemIndex }))
                                    .sort((a, b) => {
                                        const aSortIdx = Number(a?.item?.attr?.sortIdx ?? a?.item?.sortIdx)
                                        const bSortIdx = Number(b?.item?.attr?.sortIdx ?? b?.item?.sortIdx)
                                        const aValue = Number.isFinite(aSortIdx) ? aSortIdx : Number.MAX_SAFE_INTEGER
                                        const bValue = Number.isFinite(bSortIdx) ? bSortIdx : Number.MAX_SAFE_INTEGER
                                        if (aValue !== bValue) return aValue - bValue
                                        return a.itemIndex - b.itemIndex
                                    })
                                    .map(({ item }) => item)
                                : (item1 || [])
                                return <React.Fragment key={index}>
                                    {
                                        <div className={styles.Title}>
                                            <div className={styles.TitleMain}>
                                                <ProjectDetailGroupsTitle
                                                    item={item1[0]}
                                                    imageType={item1?.[0]?.imageType}
                                                />
                                            </div>
                                            {
                                                (!IsEiEdit && !isOrgData) && (
                                                    <div className={styles.TitleActions}>
                                                        <Button style={{ width: 120, height: 32 }} loading={rebuildLoading[index]} onClick={() => rebuildClick(item1, index)} >重新编辑</Button>
                                                        {!isSmartDetailProject && (
                                                            <Button
                                                                style={{ width: 120, height: 32 }}
                                                                loading={recreateLoading[index]}
                                                                onClick={() => {
                                                                    if (item1?.[0]?.imageType === IMAGE_TYPE.COMMODITY && item1?.[0]?.version !== 'V3.8.20251127') {
                                                                        rebuildClick(item1, index, true)
                                                                    } else {
                                                                        createAgain(item1, index)
                                                                    }
                                                                }}
                                                            >
                                                                再次生成
                                                            </Button>
                                                        )}
                                                    </div>
                                                )
                                            }
                                        </div>
                                    } {
                                    displayItems.map((item2) => (
                                            <div
                                                key={item2.taskId}
                                            className={`${styles.ContentItem} ${isSmartDetailProject ? styles.SmartDetailContentItem : ''}`}
                                            >
                                                <PictureResultItem
                                                    displayType={DISPLAY_TYPE.PROJECT}
                                                    item={item2}
                                                    imageType={item2?.imageType}
                                                    hideBottomMenu={
                                                        isSmartDetailProject
                                                        || imageType === IMAGE_TYPE.IMAGE_OUTPAINTING
                                                        || item2?.imageType === IMAGE_TYPE.IMAGE_OUTPAINTING
                                                    }
                                                    handleCLick={() => handleCLick(item2)}
                                                    isSelected={isSelected}
                                                    selectedList={selectedList}
                                                    selectCurrentItem={selectCurrentItem}
                                                    fetchProjectDetail={fetchProjectDetail}
                                                    rawTasks={rawTasks}
                                                    changeModelOrSenceClick={changeModelOrSenceClick}
                                                    handleReclipa={handleReclipa}
                                                />
                                            {isSmartDetailProject && item2?.status === 'succeeded' && !item2?.refTemplate && SMART_DETAIL_COMP_LABEL_MAP?.[Number(item2?.comp)] && (
                                                <div className={styles.CompTag}>
                                                    {SMART_DETAIL_COMP_LABEL_MAP[Number(item2?.comp)]}
                                                </div>
                                            )}
                                            {isSmartDetailProject && item2?.status === 'succeeded' && (
                                                <p
                                                    className={`${styles.ChooseBtn} ${item2?.picked ? styles.ChooseBtnActive : ''}`}
                                                    onClick={(e) => handlePickImage(e, item2)}
                                                >
                                                    <Iconfont className={styles.Icon} type="icon-imgOutlined" />
                                                    {item2?.picked ? '已选中' : '选这张'}
                                                </p>
                                            )}
                                            {isSmartDetailProject && item2?.status === 'succeeded' && (
                                                <span
                                                    className={styles.MaterialEditTrigger}
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        openMaterialEditModal(item2)
                                                    }}
                                                >
                                                    <Iconfont type="icon-Material-EditOutlined" />
                                                </span>
                                            )}
                                            </div>
                                        ))
                                    }
                                    <p style={{ marginBottom: '50px', width: '100%' }}></p>
                                </React.Fragment>
                            })
                        }
                    </div>
                    {isSmartDetailProject && (
                        <>
                            <div className={styles.SmartDetailPreviewSide}>
                                <SmartDetailPagePreview tasks={pickedSortedItems} isGenerating={isSmartDetailGenerating} />
                            </div>
                            <div className={styles.SmartDetailBottomActions}>
                                <PreviewBottomActions
                                    imageUrls={previewImageUrls}
                                    selectedTaskIds={selectedTaskIds}
                                />
                            </div>
                        </>
                    )}
                </div>
            </div>

            <Modal
                open={isModalOpen}
                onOk={() => setIsModalOpen(false)}
                footer={null}
                maskClosable
                // closable={false}
                width="100%"
                style={{ top: 0, padding: 0, margin: 0, maxWidth: '100vw', height: '100vh' }}
                bodyStyle={{ height: '100vh', overflow: 'hidden' }}
                destroyOnHidden
                onCancel={() => setIsModalOpen(false)}
                className={styles.PictureViewModal}
                afterOpenChange={(open) => setModalOpenFlag(open)}
                closeIcon={false}
            >
                <PictureViewModal
                    ref={modalRef}
                    projectImageType={imageType}
                    modalOpenFlag={modalOpenFlag}
                    taskId={taskId}
                    setTaskId={setTaskId}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    item={item}
                    setItem={setItem}
                    groupedTasks={groupedTasks}
                    fetchProjectDetail={fetchProjectDetail}
                    onOpenMaterialEdit={openMaterialEditModal} />
            </Modal>

            <ChangeModel ref={changeModelRef} fetchProjectDetail={fetchProjectDetail} />
            {contextHolder}
            <MaterialEditModal
                open={materialModalOpen}
                onCancel={() => {
                    setMaterialModalOpen(false)
                    setMaterialEditItem(null)
                }}
                item={materialEditItem}
                onGenerate={handleMaterialGenerate}
                generating={materialGenerating}
            />
            <PSAIModal
                title="复刻模特背景"
                open={replicaOpen}
                onOk={handleReplicaOk}
                onCancel={() => setReplicaOpen(false)}
                okButtonProps={{
                    icon: (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img style={{ width: '8px', height: '8px', marginRight: '5px' }} src={require('@assets/images/arcbean2.png')} /> {replicaCost}
                        </div>
                    ),
                    iconPosition: 'end',
                    disabled: replicaFiles.length == 0
                }}
            >
                <ReplicaForm record={replicaOf} onChange={handleReplicaChange} />
            </PSAIModal>
        </div>
    )
}

export default ProjectDetailPage
